import { Injectable } from '@angular/core';

declare const P4: any;
declare const $: any;

@Injectable()
export default class P4FacadeService {

  onClickClose() {
    P4.modules.customModal.onClickClose();
  }
}
